<ngx-spinner>
  <p class="loading" style="color: white; margin-top: 6.5rem;">Cargando...</p>
</ngx-spinner>
<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>
